import { TOOLS_IDS } from './constants';
import {
  isGoogleTextFontFamily,
  resolveFontFamilyForCanvas,
} from '../../../fontFamilyRegistry';

export { resolveFontFamilyForCanvas };

/**
 * Single-weight local @font-face files must not also get canvas "bold" — that
 * faux-bolds display faces (e.g. Anton mislabeled as Antonio) and breaks template layout.
 */
export const resolveCanvasFontStyle = (fontFamily, fontStyle = 'normal') => {
  if (isGoogleTextFontFamily(fontFamily)) {
    return fontStyle || 'normal';
  }

  const tokens = String(fontStyle || 'normal')
    .toLowerCase()
    .split(/\s+/)
    .filter((token) => token && token !== 'bold');

  return tokens.length > 0 ? tokens.join(' ') : 'normal';
};

const normalizeAnnotationFontStylesForLoad = (annotations = {}) => {
  if (!annotations || typeof annotations !== 'object') {
    return annotations;
  }

  return Object.fromEntries(
    Object.entries(annotations).map(([id, annotation]) => {
      if (annotation?.name !== TOOLS_IDS.TEXT || !annotation.fontFamily) {
        return [id, annotation];
      }

      const fontStyle = resolveCanvasFontStyle(
        annotation.fontFamily,
        annotation.fontStyle,
      );

      if (fontStyle === annotation.fontStyle) {
        return [id, annotation];
      }

      return [id, { ...annotation, fontStyle }];
    }),
  );
};

export default normalizeAnnotationFontStylesForLoad;
